<template>
  <span :class="bem()" aria-hidden="true">
    <span v-if="status !== 1 && isInited">
      <span v-if="parseInt(d) !== 0" class="d-ct">
        <span class="bolder">{{ d }}</span>
        <em class="day">天</em>
      </span>
      <span v-if="showPlainText">
        <span class="bolder">{{ h }}</span>
        <em class="risk">时</em>
        <span class="bolder">{{ m }}</span>
        <em class="risk">分</em>
        <span v-if="isShowSecond">
          <span class="bolder">{{ s }}</span>
          <em class="risk">秒</em>
        </span>
        <span v-if="showMSecond" class="ms">
          <em class="risk">.</em>
          <span class="tbg">{{ ms }}</span>
        </span>
      </span>
      <span v-else>
        <template v-if="!hiddenHour">
          <span class="tbg">{{ h }}</span>
          <em class="risk">:</em>
        </template>
        <span class="tbg">{{ m }}</span>
        <span v-if="isShowSecond">
          <em class="risk">:</em>
          <span class="tbg">{{ s }}</span>
        </span>
        <span v-if="showMSecond" class="ms">
          <em class="risk">.</em>
          <template v-if="showMSecondGif">
            <span
              class="ms-gif"
              v-if="isMSecondGifShow"
              :style="{
                backgroundImage: 'url(' + msGifUrl + ')'
              }"
            ></span>
          </template>
          <span class="tbg" v-else>{{ ms }}</span>
        </span>
      </span>
    </span>
  </span>
</template>

<script>
import create from '../create'
import interval from 'utils/interval'

export default create({
  name: 'count-down',

  props: {
    current: {
      type: Number,
      default: +new Date()
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    leaveDay: {
      type: Number,
      default: 3
    },
    showPlainText: {
      type: Boolean,
      default: false
    },
    showSecond: {
      type: Boolean,
      default: true
    },
    // 是否展示百毫秒倒计时
    showMSecond: {
      type: Boolean,
      default: false
    },
    // 毫秒展示实际数据还是gif，gif用于解决多个倒计时的性能问题
    showMSecondGif: {
      type: Boolean,
      default: false
    },
    initFun: {
      type: Function
    },
    startFun: {
      type: Function
    },
    endFun: {
      type: Function
    },
    visibilityChange: {
      type: Function
    },
    // 是否隐藏小时
    hiddenHour: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      time: 0,
      status: 0,
      ms: 0,
      isInited: false, // 是否已初始化，解决默认展示0的问题
      intervalNum: 0, // 秒定时器
      timeTick: '',
      intervalMS: 0,
      isMSecondGifShow: false, // 倒计时gif是否展示，通过不同延迟错开展示
      msGifUrl: 'https://topicstatic.vivo.com.cn/f5ZUD0HxhQMn3J32/wukong/img/f5809d4b-5869-4bab-b90a-9df5faddf752.gif' // 倒计时gif图片url
    }
  },
  computed: {
    d() {
      return Math.floor(this.time / (3600000 * 24))
    },
    h() {
      return parseInt(this.time / 3600000) % 24 > 9
        ? parseInt(this.time / 3600000) % 24
        : '0' + (parseInt(this.time / 3600000) % 24)
    },
    m() {
      return parseInt(this.time / 60000) % 60 > 9
        ? parseInt(this.time / 60000) % 60
        : '0' + (parseInt(this.time / 60000) % 60)
    },
    s() {
      return parseInt((this.time % 60000) / 1000) > 9
        ? parseInt((this.time % 60000) / 1000)
        : '0' + parseInt((this.time % 60000) / 1000)
    },
    isShowSecond() {
      // 支持配置是否显示秒，如果不显示秒，计时到1分钟内自动显示出秒倒计时
      if (!this.showSecond) {
        return !!(parseInt(this.d) === 0 && parseInt(this.h) === 0 && parseInt(this.m) === 0)
      } else {
        return true
      }
    }
  },
  filters: {
    formatData(value) {
      const month = new Date(1047500400).getMonth() + 1
      const day = new Date(1047500400).getDate()
      return month + '月' + day + '日' + new Date(1047500400).toLocaleTimeString()
    }
  },
  watch: {
    current: {
      handler(val) {
        this.init()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // 初始化定时器当前服务器时间
      // 去掉if,离屏渲染缓存每次都要更新
      // if (!interval.hasInited) {
        interval.init(this.current)
      // }
      let currentTime = interval.time
      if (this.timeTick) {
        interval.remove(this.timeTick)
      }
      if (this.showMSecond) {
        if (!this.showMSecondGif) {
          clearInterval(this.intervalMS)
          // 百毫秒倒计时,延迟1秒启动
          this.setIntervalMS()
        } else {
          // 倒计时gif生成不同的url，并设置不同时间展示，用于模拟不同倒计时
          let timer = parseInt(Math.random() * 500, 10)
          this.msGifUrl += '?t=' + timer
          setTimeout(() => {
            this.isMSecondGifShow = true
          }, timer)
        }
      }
      if (currentTime < this.start) {
        // 距离开始
        this.time = this.start - currentTime
        this.status = -1
        this.interval()
      } else if (currentTime < this.end) {
        // 距离结束
        this.time = this.end - currentTime
        this.status = 0
        this.interval()
      } else {
        // 活动结束
        this.status = 1
      }
      this.isInited = true
      this.initFun && this.initFun(this.status)
    },
    setIntervalMS() {
      this.intervalMS = setInterval(() => {
        this.ms--
        if (this.ms == -1) {
          this.ms = 9
        }
      }, 100)
    },
    interval() {
      // 定时器回调执行
      this.timeTick = currentTime => {
        if (this.status == -1) {
          this.time = this.start - currentTime
        } else if (this.status == 0) {
          this.time = this.end - currentTime
        } else {
          this.time = 0
        }
        if (this.time < 1000) {
          clearInterval(this.intervalMS)
          this.isMSecondGifShow = false
        }
        if (this.time <= 0) {
          if (this.status === -1) {
            // 活动开始
            this.status = 0
            this.startFun && this.startFun()
            this.time = this.end - this.start
            this.time -= 1000
          } else {
            // 活动结束
            this.status = 1
            this.endFun && this.endFun()
            clearInterval(this.intervalMS)
            interval.remove(this.timeTick)
          }
        } else {
          this.time -= 1000
          if (this.time < 0) {
            this.time = 0
          }
        }
      }
      // 定时器回调加入队列
      interval.add(this.timeTick)
    },
    getStatus() {
      return this.status
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalMS)
    interval.remove(this.timeTick)
  }
})
</script>

<style lang="scss">
.bolder {
  @include os-font-weight-number(36, 50);
}
.ms-gif {
  display: inline-block;
  width: 18px;
  height: 27px;
  background-size: 100% 100%;
  vertical-align: baseline;
}
</style>
